const isMainNavEnabled = false;
export default [
  {
    path: 'executivesummary',
    name: 'Executive Summary',
    component: () => import( '../views/ExecutiveSummary.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'summary',
    name: 'Summary',
    component: () => import( '../views/Summary.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'materialVisibility',
    name: 'Material Visibility',
    component: () => import('../views/MaterialVisibility.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  
  {
    path: 'expeditingReport',
    name: 'Expediting Report',
    component: () => import('../views/ExpeditingReport.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'originalexpeditingReport',
    name: 'Original Expediting Report',
    component: () => import('../views/OriginalExpeditingReport.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'planning',
    name: 'Material Planning',
    component: () => import('../views/Planning.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'users',
    name: 'Users',
    component: () => import('../views/Admin/Users.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'emailsetup',
    name: 'Email Setup',
    component: () => import('../views/Admin/EmailSetup.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'milestone',
    name: 'Milestone Master',
    component: () => import( '../views/Admin/MilestoneMaster.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'materialapplicability',
    name: 'Material Applicability',
    component: () => import( '../views/Admin/MaterialApplicability.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'tawbsmapping',
    name: 'TAWBS mapping',
    component: () => import( '../views/Admin/TAWBSMapping.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'managecategoriessegments',
    name: 'Categories and Segments',
    component: () => import( '../views/Admin/CategorySegments.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'milestoneMasterSummary',
    name: 'Milestone Master Summary',
    component: () => import( '../views/MilestoneMasterSummary.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'projectSourcingSchedule',
    name: 'Project Sourcing Schedule',
    component: () => import( '../views/Gewerke.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'sourcingschedule',
    name: 'Sourcing Schedule',
    component: () => import( '../views/SourcingSchedule.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'llvisibilityreport',
    name: 'Visibility Report',
    component: () => import( '../views/LLVisibilityReport.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'notfound',
    name: 'notfound',
    component: () => import(/* webpackChunkName: "admin-owners" */ '../views/PageNotFound.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    }
  },
]
